import api from './api';

export const perguntarIa = async (pergunta, confirmarOperacao = false) => {
  const response = await api.post('/ia/perguntar', { pergunta, confirmarOperacao });

  return response.data;
};
